<ng-content></ng-content>




// WEBPACK FOOTER //
// ./src/app/layout/components/platTopMenu/platTopMenu.component.html